import { attr, Model, ModelType } from 'redux-orm';
import { GET_NBAS_SUCCESS, REMOVE_NBA } from 'actions';
import moment, { Moment } from 'moment';
import { getLocalStorage, setLocalStorage } from 'utils/localStorage';

export enum NbaType {
  CONTACT_REFERRED = 'CONTACT_REFERRED',
  DORMANT_CONTACT = 'DORMANT_CONTACT',
  FOLLOW_UP_INTERACTION = 'FOLLOW_UP_INTERACTION',
}

export enum ActionType {
  CONTACT_DASHBOARD = 'CONTACT_DASHBOARD',
  INTERACTION_DETAIL = 'INTERACTION_DETAIL',
}

export interface ActionData {
  contactId?: string;
  companyId: string;
  interactionId?: string;
}

export interface INba {
  accountId: string;
  actionData: ActionData;
  actionType: ActionType;
  content: string;
  displayExpiry: string;
  id: string;
  nbaType: NbaType;
  templateFile: string;
  timestamp: string;
  userId: string;
}

export interface ExpiringNba extends INba {
  expiry: Moment;
}

interface Action {
  type: string;
  id?: string;
  data?: INba[];
  error?: string;
}

class Nba extends Model<typeof Nba, INba> {
  static reducer(action: Action, model: ModelType<Nba>) {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case GET_NBAS_SUCCESS: {
        /*
          TODO: remove side effect from reducer
        */
        if (!action.data) {
          break;
        }
        const removedNBAs: Record<string, ExpiringNba> = getLocalStorage(
          'removedNBAs',
          {},
        );
        action.data.forEach((d) => {
          if (removedNBAs[d.id]) {
            if (moment().isAfter(removedNBAs[d.id].expiry)) {
              delete removedNBAs[d.id];
              model.upsert(d);
            }
          } else {
            model.upsert(d);
          }
        });
        setLocalStorage('removedNBAs', removedNBAs);
        break;
      }
      case REMOVE_NBA:
        if (!action.id) {
          break;
        }
        model.withId(action.id)?.delete();
        break;
    }
  }

  toViewModel() {
    return {
      ...this.ref,
    };
  }
}

Nba.modelName = 'Nba';

Nba.fields = {
  id: attr(),
  accountId: attr(),
  actionData: attr(),
  actionType: attr(),
  content: attr(),
  displayExpiry: attr(),
  nbaType: attr(),
  userId: attr(),
  timestamp: attr(),
};

export type NbaViewModel = ReturnType<Nba['toViewModel']>;

export default Nba;
